module.exports = __webpack_public_path__ + "media/images/unsplash_img-p-130x130q80-36da5886a8dcea71ad37d8e16d351b1f.jpeg";